export const templateTypography: Record<
  string,
  { family: string; size: number; lineHeight: number; variants: string[] }
> = {
  "clinical-calm": {
    family: "Inter",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "600", "700"],
  },
  "sales-focus": {
    family: "Inter",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "600", "600italic", "700"],
  },
  "account-balance": {
    family: "Figtree",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "600", "700"],
  },
  "citrus-bloom": {
    family: "Lato",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "plum-timeline": {
    family: "Open Sans",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "mono-content": {
    family: "Arimo",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "linen-ledger": {
    family: "Poppins",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "charcoal-monogram": {
    family: "Montserrat",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "cobalt-balance": {
    family: "Roboto",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "royal-line": {
    family: "Open Sans",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "silver-ledger": {
    family: "Open Sans",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "navy-summit": {
    family: "Open Sans",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "dune-flow": {
    family: "Poppins",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "blue-horizon": {
    family: "Figtree",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "slate-ledger": {
    family: "Figtree",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "editorial-muse": {
    family: "EB Garamond",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "600", "700"],
  },
  "sand-profile": {
    family: "Figtree",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "blue-wave": {
    family: "Lato",
    size: 15.4,
    lineHeight: 1.3,
    variants: ["regular", "italic", "700"],
  },
  "code-clarity": {
    family: "Figtree",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "500", "600"],
  },
  "fiscal-arch": {
    family: "Raleway",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "500", "700"],
  },
  "soft-contour": {
    family: "Montserrat",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "500", "500italic", "700"],
  },
  "sage-orbit": {
    family: "Figtree",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "600", "700"],
  },
  "azure-frame": {
    family: "Figtree",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "600", "700"],
  },
  "forest-frame": {
    family: "Lato",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "brand-mocha": {
    family: "Open Sans",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "600"],
  },
  "fresh-start": {
    family: "Nunito Sans",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "600", "700"],
  },
  "legal-distinction": {
    family: "Lato",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "700"],
  },
  "marketing-pulse": {
    family: "Figtree",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "500", "600"],
  },
  "people-first": {
    family: "Figtree",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "500", "600"],
  },
  "structural-line": {
    family: "Outfit",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "500", "600", "700"],
  },
  "project-flow": {
    family: "Open Sans",
    size: 11,
    lineHeight: 1.4,
    variants: ["regular", "italic", "500", "600", "700"],
  },
};
